import { Box, Chip, FormControl, styled, Theme, InputLabel } from "@mui/material";
import { ElementType, useState } from "react";
import { spacing } from "@my-helpers/common";

const StyledChip = styled(Chip)(({ theme }: { theme: Theme }) => ({
    background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.dark})`,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '& .MuiChip-deleteIcon': {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        '&:hover': {
            color: theme.palette.getContrastText(theme.palette.primary.main),
        },
    },
}));

interface TagsProps {
    tags: string[];
    handleInputChange: (tags: string[]) => void;
}

export const Tags: ElementType<TagsProps> = ({ tags, handleInputChange }) => {
    const [newTag, setNewTag] = useState('');

    const handleAddTag = () => {
        if (newTag.trim() && !tags.includes(newTag.trim())) {
            handleInputChange([...tags, newTag.trim()]);
            setNewTag('');
        }
    };

    const handleRemoveTag = (tagToRemove: string) => {
        handleInputChange(tags.filter(tag => tag !== tagToRemove));
    };
    return (
        <FormControl 
            variant="outlined" 
            sx={{ 
                height: '92px',
                display: 'flex',
                flexGrow: 1
            }}>
            <InputLabel 
                shrink={tags.length > 0 || newTag.length > 0}
                sx={{
                    backgroundColor: 'white',
                }}
            >
                Tags
            </InputLabel>
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'border.default',
                    borderRadius: `${spacing.borderRadius.medium}px`,
                    padding: '8px',
                    height: '72px',
                    overflow: 'auto',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    alignItems: 'center',
                    alignContent: 'flex-start',
                    cursor: 'text',
                    '&:hover': {
                        borderColor: 'border.hover',
                    },
                    '&:focus-within': {
                        borderColor: 'primary.main',
                        borderWidth: '2px',
                    },
                }}
                onClick={() => {
                    const input = document.getElementById('tags-input');
                    if (input) input.focus();
                }}
            >
                {tags.map((tag) => (
                    <StyledChip
                        key={tag}
                        label={tag}
                        onDelete={() => handleRemoveTag(tag)}
                        size="small"
                    />
                ))}
                <input
                    id="tags-input"
                    type="text"
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddTag();
                        }
                    }}
                    style={{
                        border: 'none',
                        outline: 'none',
                        background: 'transparent',
                        minWidth: '100px',
                        flex: 1,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                        color: 'inherit',
                        height: '32px',
                        lineHeight: '32px',
                    }}
                />
            </Box>
            <Box sx={{
                height: '20px',
                fontSize: '0.75rem',
                color: 'transparent'
            }}>
                &nbsp;
            </Box>
        </FormControl>
    )
}
